(() => {
  /*============================================================================
   Mini cart custom functions
  ==============================================================================*/

  /**
   * Event listeners on mini cart DOM items.
   *
   * @param none
   */

  const eventListeners = () => {
    const handleCartUpdate = () => {
      setTimeout(helpers.restructureMiniCartItems, 750);
    };

    document.addEventListener("shopifyCartUpdated", handleCartUpdate);
    document.addEventListener("bundleAdded", handleCartUpdate);
  };

  /**
   * Load event on mini cart.
   *
   * @param none
   */

  const onLoad = async () => {
    domItems = {
      bundleItems: document.querySelectorAll(".bundle-item"),
      cartItems: document.querySelectorAll(".cart_item"),
    };

    eventListeners();
  };

  if (document.readyState === "complete") {
    onLoad();
  } else {
    window.addEventListener("load", onLoad);
  }
})();
